/*
 * 配合react-infinite-scroll-component使用
 * 當需要scrollableTarget時(在element scroll而不是window)
 * 須給定element實際的height pixel
 */
import { useState, useEffect, useCallback, useRef } from 'react'
import styled from '@emotion/styled'
import { useRouter } from 'next/router'
import { useStateRef } from 'utils/hooks/dom'
import useDeepCompareEffect from 'use-deep-compare-effect'
import { useShowScrollToTopButton } from 'utils/hooks'
import ScrollToTopButton from 'components/common/ScrollToTopButton'

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: hidden;
`

const HeightSyncToContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: ${(props) => props.height}px;
  overflow-y: auto;
`

const InfiniteContainer = ({
  children,
  id,
  containerRef,
  filterState = {},
  ...rest
}) => {
  const router = useRouter()
  const { page } = router?.query || {}
  const [node, nodeRef] = useStateRef()
  const [height, setHeight] = useState()
  const scrollableRef = useRef(null)
  const { showButton, showScrollButton } = useShowScrollToTopButton()

  // 判斷當有頁面 query 且改變時為點擊換頁，使頁面置頂
  useEffect(() => {
    if (router?.pathname === '/vender' && page) {
      setTimeout(
        () =>
          scrollableRef?.current &&
          scrollableRef?.current?.scrollTo({
            top: 0,
            behavior: 'smooth',
          }),
        0
      )
    }
  }, [page, filterState])

  useEffect(() => {
    if (scrollableRef?.current && containerRef) {
      containerRef.current = scrollableRef?.current
    }
  }, [scrollableRef?.current, containerRef])

  const handleResize = useCallback(() => {
    if (node) {
      setHeight(node.clientHeight)
    }
  }, [node])

  useEffect(() => {
    if (!node) {
      return
    }
    const observer = new ResizeObserver(handleResize)
    observer.observe(node)

    return () => {
      observer.unobserve(node)
    }
  }, [node, handleResize])

  return (
    <Container ref={nodeRef}>
      <HeightSyncToContainer
        height={height}
        id={id}
        ref={scrollableRef}
        onScroll={showScrollButton}
      >
        {children}
        <ScrollToTopButton
          showButton={showButton}
          scrollableRef={scrollableRef}
        />
      </HeightSyncToContainer>
    </Container>
  )
}

export default InfiniteContainer
